var Vector = function (elements) {
    this.elements = elements instanceof Array ? elements : [elements];
};

Vector.ZERO = new Vector(0);
Vector.ZERO.flag = "__ZERO__";

Vector.INFINITY = new Vector(Infinity);
Vector.INFINITY.flag = "__INFINITY__";

Vector.MINUS_INFINITY = new Vector(-Infinity);
Vector.MINUS_INFINITY.flag = "__MINUS_INFINITY__";

Vector.compare = function (a, b) {
    var aElements = a.elements;
    if(a === Vector.ZERO || a === Vector.INFINITY || a === Vector.MINUS_INFINITY)
        aElements = b.elements.map(function () { return a.elements[0]; });
    var bElements = b.elements;
    if(b === Vector.ZERO || b === Vector.INFINITY || b === Vector.MINUS_INFINITY)
        bElements = a.elements.map(function () { return b.elements[0]; });

    if(aElements.length === bElements.length) {
        for(var i=0; i<aElements.length; i++) {
            if (aElements[i] < bElements[i]) return -1;
            if (aElements[i] > bElements[i]) return 1;
        }
        return 0;
    } else {
        throw new Error("Cannot compare two vectors with different dimensions");
    }
};

Vector.add = function (a, b) {
    if(a === Vector.ZERO) {
        switch (b) {
            case Vector.ZERO: return Vector.ZERO;
            case Vector.INFINITY: return Vector.INFINITY;
            case Vector.MINUS_INFINITY: return Vector.MINUS_INFINITY;
        }
    } else if(a === Vector.INFINITY) {
        switch (b) {
            case Vector.ZERO: return Vector.INFINITY;
            case Vector.INFINITY: return Vector.INFINITY;
            case Vector.MINUS_INFINITY: return Vector.ZERO;
        }
    } else if(a === Vector.MINUS_INFINITY) {
        switch (b) {
            case Vector.ZERO: return Vector.MINUS_INFINITY;
            case Vector.INFINITY: return Vector.ZERO;
            case Vector.MINUS_INFINITY: return Vector.MINUS_INFINITY;
        }
    }

    var aElements = a.elements;
    if(a === Vector.ZERO || a === Vector.INFINITY || a === Vector.MINUS_INFINITY)
        aElements = b.elements.map(function () { return a.elements[0]; });
    var bElements = b.elements;
    if(b === Vector.ZERO || b === Vector.INFINITY || b === Vector.MINUS_INFINITY)
        bElements = a.elements.map(function () { return b.elements[0]; });

    var elements = [];
    if(aElements.length === bElements.length) {
        for(var i=0; i<aElements.length; i++) {
            elements[i] = aElements[i] + bElements[i];
        }
        switch(elements) {
            case Vector.ZERO.elements:
                return Vector.ZERO;
            case Vector.INFINITY.elements:
                return Vector.INFINITY;
            case Vector.MINUS_INFINITY.elements:
                return Vector.MINUS_INFINITY;
            default:
                return new Vector(elements);
        }
    } else {
        throw new Error("Cannot add two vectors with different dimensions");
    }
};

Vector.sub = function (a, b) {
    if(a === Vector.ZERO) {
        switch (b) {
            case Vector.ZERO: return Vector.ZERO;
            case Vector.INFINITY: return Vector.MINUS_INFINITY;
            case Vector.MINUS_INFINITY: return Vector.INFINITY;
        }
    } else if(a === Vector.INFINITY) {
        switch (b) {
            case Vector.ZERO: return Vector.INFINITY;
            case Vector.INFINITY: return Vector.ZERO;
            case Vector.MINUS_INFINITY: return Vector.INFINITY;
        }
    } else if(a === Vector.MINUS_INFINITY) {
        switch (b) {
            case Vector.ZERO: return Vector.MINUS_INFINITY;
            case Vector.INFINITY: return Vector.MINUS_INFINITY;
            case Vector.MINUS_INFINITY: return Vector.ZERO;
        }
    }

    var aElements = a.elements;
    if(a === Vector.ZERO || a === Vector.INFINITY || a === Vector.MINUS_INFINITY)
        aElements = b.elements.map(function () { return a.elements[0]; });
    var bElements = b.elements;
    if(b === Vector.ZERO || b === Vector.INFINITY || b === Vector.MINUS_INFINITY)
        bElements = a.elements.map(function () { return b.elements[0]; });

    var elements = [];
    if(aElements.length === bElements.length) {
        for(var i=0; i<aElements.length; i++) {
            elements[i] = aElements[i] - bElements[i];
        }
        switch(elements) {
            case Vector.ZERO.elements:
                return Vector.ZERO;
            case Vector.INFINITY.elements:
                return Vector.INFINITY;
            case Vector.MINUS_INFINITY.elements:
                return Vector.MINUS_INFINITY;
            default:
                return new Vector(elements);
        }
    } else {
        throw new Error("Cannot subtract two vectors with different dimensions");
    }
};

Vector.prototype.dimension = function(){
    return this.elements.length;
};

Vector.prototype.compare = function (other) {
    return Vector.compare(this, other);
};

Vector.prototype.equals = function (other) {
    return Vector.compare(this, other) === 0;
};

Vector.prototype.lessThan = function (other) {
    return Vector.compare(this, other) < 0;
};

Vector.prototype.greaterThan = function (other) {
    return Vector.compare(this, other) > 0;
};

Vector.prototype.add = function (other) {
    return Vector.add(this, other);
};

Vector.prototype.sub = function (other) {
    return Vector.sub(this, other);
};

module.exports = Vector;
